<template>
  <div id="scroll-board">
    <dv-scroll-board :config="config"/>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ScwlContractScrollBoard',
    computed: {
      ...mapState('bigScreenData', ['waybillScrollList'])
    },
    watch: {
      waybillScrollList (val, old) {
        let data = []
        for (let li of val) {
          let item = [li.contractName, li.clientName, li.waybillCount]
          data.push(item)
        }
        this.config = {
          header: ['项目名称', '货主', '运单数量'],
          data: data,
          // index: true,
          columnWidth: [120, 240],
          align: ['left'],
          rowNum: 5,
          headerBGC: 'rgba(5,22,65,0.76)',
          headerHeight: 30,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)'
        }
      },
    },
    data () {
      return {
        config: {
          header: ['项目名称', '货主', '运单数量'],
          data: [
          ],
          // index: true,
          columnWidth: [120, 240],
          align: ['left'],
          rowNum: 5,
          headerBGC: 'rgba(5,22,65,0.76)',
          headerHeight: 30,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)'
        }
      }
    }
  }
</script>

<style lang="less">
  #scroll-board {
    width: 100%;
    box-sizing: border-box;
    margin-left: 20px;
    height: 60%;
    overflow: hidden;
  }
</style>
